<template>
  <div :class="classObject">
    <InputfieldDescription
      :text="description"
    >
      <slot name="description" />
    </InputfieldDescription>
    <div class="field__content">
      <button
        :type="type"
        v-bind="[$attrs, $listeners]"
        :class="[
          'button',
          color ? 'button--' + color : null,
        ]"
        @click="$emit('click')"
        :disabled="disabled"
      >
        <font-awesome-icon
          v-if="loading"
          icon="circle-notch"
          class="button__icon"
          spin
        />
        <template v-else>
          <font-awesome-icon
            v-if="icon"
            :icon="icon"
            class="button__icon"
          />
          <span
            class="button__text"
            v-html="text"
          />
        </template>
      </button>
    </div>
    <InputfieldErrors :items="parsedErrors" />
    <InputfieldNotes :text="notes">
      <slot name="notes" />
    </InputfieldNotes>
  </div>
</template>

<script>

import InputfieldMixin from '@/components/forms/InputfieldMixin'
import InputfieldDescription from '@/components/forms/InputfieldDescription'
import InputfieldNotes from '@/components/forms/InputfieldNotes'

export default {
  name: 'InputfieldButton',
  inheritAttrs: false,
  mixins: [
    InputfieldMixin,
  ],
  components: {
    InputfieldDescription,
    InputfieldNotes,
  },
  props: {
    type: {
      type: String,
      required: false,
      default () {
        return 'button'
      },
    },
    color: {
      type: [String, Number],
      required: false,
      default () {
        return ''
      },
    },
    text: {
      type: [String, Number],
      required: false,
      default () {
        return 'Submit'
      },
    },
    icon: {
      type: [String, Number],
      required: false,
      default () {
        return ''
      },
    },
    loading: {
      type: Boolean,
      required: false,
      default () {
        return false
      },
    },
    disabled: {
      type: Boolean,
      required: false,
      default () {
        return false
      },
    },
  },
  computed: {
    classObject () {
      return [
        'field',
        'field--button',
        this.disabled ? 'field--disabled' : null,
      ]
    },
  },
}

</script>

<style lang="scss">

</style>
